var FcLocationSectorInputModule = /** @class */ (function () {
    function FcLocationSectorInputModule() {
    }
    return FcLocationSectorInputModule;
}());
export { FcLocationSectorInputModule };
